export default {
      id: "social-small-youtube-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#social-small-youtube",
      toString: function () {
        return this.url;
      }
    }